import React, { useState, useEffect, useMemo } from "react";
import ReactDOM from "react-dom";
import Login from "../../login/Login";
import { getData, postData } from "../../../components/helpers/Data";
import { Spinner } from "../../../components/helpers/Spinner";
import MessageModal from "../../../components/helpers/Modal2";
import { toInputUpperCase } from "../../../components/helpers/toInputUpperCase";
import Modal5 from "../../../components/helpers/Modal5";
import { userSaveDetails } from "../../../components/helpers/UserSaveDetails";
import { Link } from "react-router-dom";
import { today } from "../../../components/helpers/today";
import * as XLSX from "xlsx";

const AddStock = () => {
  //create array for logs when renewing corp
  const logData = userSaveDetails(5);

  //module variables
  const [stockData, setStockData] = useState({ all: [], filtered: [] });
  const [items, setItems] = useState([]);
  const [units, setUnits] = useState([]);
  const [searchQuery, setSearchQuery] = useState([]);
  const [appendedStock, setAppendedStock] = useState([]);
  const [messageModal, setIsMessageModal] = useState(false);
  const [responseModal, setResponseModal] = useState(false);
  const [response, setResponse] = useState(false);
  const [message, setMessage] = useState(false);
  const [stockImportData, setStockImportData] = useState([]);
  const [memberColumns, setMemberColumns] = useState([]);
  let index = 0;

  useEffect(() => {
    getData("fetch_items_stock")
      .then((data) => {
        setItems(data);
      })
      .catch((error) => {
        console.log(error);
      });
    getData("fetch_stock")
      .then((data) => {
        setStockData({ all: data, filtered: data });
      })
      .catch((error) => {
        console.log(error);
      });
    getData("fetch_units")
      .then((data) => {
        setUnits(data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  //read excel
  const readExcel = (file) => {
    document.getElementById("spinner").style.display = "block";
    setStockImportData([]);
    setMemberColumns([]);
    const promise = new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      if (file) {
        fileReader.readAsArrayBuffer(file);

        fileReader.onload = (e) => {
          const bufferArray = e.target.result;

          const wb = XLSX.read(bufferArray, {
            type: "buffer",
            cellDates: true,
            cellNF: false,
            cellText: false,
          });

          const wsname = wb.SheetNames[0];

          //get column names and validate
          const workbookHeaders = XLSX.read(bufferArray, {
            sheetRows: 1,
          });
          const columns = XLSX.utils.sheet_to_json(
            workbookHeaders.Sheets[wsname],
            { header: 1 },
          )[0];
          if (
            columns[0] === "index" &&
            columns[1] === "item" &&
            columns[2] === "expiry_date" &&
            columns[3] === "wholesale_price_per_item" &&
            columns[4] === "retail_price_per_item" &&
            columns[5] === "stocked" &&
            columns[6] === "expired_or_spoilt" &&
            columns[7] === "feedback"
          ) {
            const ws = wb.Sheets[wsname];

            const data = XLSX.utils.sheet_to_json(ws, {
              raw: false,
              rawNumbers: true,
              dateNF: "YYYY-MM-DD",
            });
            setMemberColumns(columns);
            resolve(data);
          } else {
            resolve([]);
          }
        };

        fileReader.onerror = (error) => {
          reject(error);
        };
      } else {
        document.getElementById("spinner").style.display = "none";
      }
    });

    promise.then((dt) => {
      if (dt.length !== 0) {
        document.getElementById("spinner").style.display = "none";
        setStockImportData(dt);
      } else {
        document.getElementById("spinner").style.display = "none";
        setResponse("Warning! the excel columns are not correct");
        setResponseModal(true);
      }
    });
  };
  // append bank
  const appendStockRow = (e) => {
    e.preventDefault();
    const row = {
      id: new Date().getTime().toString(),
      new: (
        <>
          <td></td>
          <td>
            <select
              className={"form-control-sm items_added"}
              style={{ width: "200px" }}
            >
              <option disabled selected value="0">
                Choose Item
              </option>
              {items.map((dt) => {
                return (
                  <option value={dt.item_code}>{dt.item_detail}</option>
                );
              })}
            </select>
          </td>
          <td>
            <input
              className="form-control"
              type="date"
              name="expiry_date_added[]"
            />
          </td>

          {/* <td>
            <select
              className={"form-control-sm units_added"}
              style={{ width: "200px" }}
            >
              <option disabled selected value="0">
                Choose Units
              </option>
              {units.map((dt) => {
                return <option value={dt.code}>{dt.units}</option>;
              })}
            </select>
          </td> */}
          {/* <td>
            <input
              type="number"
              name="quantity_added[]"
              className={"form-control"}
            />
          </td> */}
          <td>
            <input
              type="number"
              name="wholesale_added[]"
              className={"form-control"}
            />
          </td>
          <td>
            <input
              type="number"
              name="retail_added[]"
              className={"form-control"}
            />
          </td>
          <td>
            <input
              type="number"
              name="stocked_added[]"
              className={"form-control"}
            />
          </td>
          <td></td>
          <td>
            <input
              type="number"
              name="quantity_expired_or_spoilt_added[]"
              className={"form-control"}
            />
          </td>
          <td></td>
          <td>
            <input type="date" className={"form-control"} value={today()} />
          </td>
          <td>
            <button
              className="btn text-danger btn-sm"
              onClick={(e) => removeStock(row.id, e)}
            >
              <i className="fas fa-trash fa-sm"></i>
            </button>
          </td>
        </>
      ),
    };

    setAppendedStock((appendedStock) => {
      return [...appendedStock, row];
    });
  };
  //remove bank row
  const removeStock = async (id, e) => {
    e.preventDefault();
    setAppendedStock((appendedStock) => {
      return appendedStock.filter((row) => row.id !== id);
    });
  };

  // Memoized filtered data
  // const filteredData = useMemo(() => {
  //   if (!searchQuery) {
  //     // If the search text is empty, return the initial data as is
  //     return ItemsData.all;
  //   }

  // Filter the data based on the search text
  //   const filtered = ItemsData.all.filter((item) => {
  //     // return console.log(item);
  //     (item.code !== null &&
  //       item.code
  //         .toString()
  //         .toLowerCase()
  //         .includes(searchQuery.toLowerCase())) ||
  //       (item.Items !== null &&
  //         item.Items
  //           .toString()
  //           .toLowerCase()
  //           .includes(searchQuery.toLowerCase())) ||
  //       (item.type_text !== null &&
  //         item.type_text.toLowerCase().includes(searchQuery.toLowerCase())) ||
  //       (item.state_text !== null &&
  //         item.state_text.toLowerCase().includes(searchQuery.toLowerCase())) ||
  //       (item.units_text !== null &&
  //         item.units_text.toLowerCase().includes(searchQuery.toLowerCase())) ||
  //       (item.quantity_per_stock !== null &&
  //         item.quantity_per_stock
  //           .toString()
  //           .toLowerCase()
  //           .includes(searchQuery.toLowerCase())) ||
  //       (item.wholesale_price_per_stock !== null &&
  //         item.wholesale_price_per_stock
  //           .toString()
  //           .toLowerCase()
  //           .includes(searchQuery.toLowerCase())) ||
  //       (item.retail_price_per_stock !== null &&
  //         item.retail_price_per_stock
  //           .toString()
  //           .toLowerCase()
  //           .includes(searchQuery.toLowerCase())) ||
  //       (item.quantity_stocked !== null &&
  //         item.quantity_stocked
  //           .toString()
  //           .toLowerCase()
  //           .includes(searchQuery.toLowerCase())) ||
  //       (item.quantity_available !== null &&
  //         item.quantity_available
  //           .toString()
  //           .toLowerCase()
  //           .includes(searchQuery.toLowerCase()));
  //   });

  //   return filtered;
  // }, [searchQuery, ItemsData.all]);

  //search stock
  const handleSearch = (e) => {
    const searchQuery = e.target.value;
    const filteredData = stockData.all.filter(
      (item) =>
        console.log(item.stock_code)(
          item.id !== null &&
            item.id.toString().toLowerCase() === searchQuery.toLowerCase(),
        ) ||
        (item.items_code !== null &&
          item.items_code.toString().toLowerCase() ===
            searchQuery.toLowerCase()),
      // (item.type_text !== null &&
      //   item.type_text.toLowerCase().includes(searchQuery.toLowerCase())) ||
      // (item.state_text !== null &&
      //   item.state_text.toLowerCase().includes(searchQuery.toLowerCase())) ||
      // (item.units_text !== null &&
      //   item.units_text.toLowerCase().includes(searchQuery.toLowerCase())) ||
      // (item.quantity_per_stock !== null &&
      //   item.quantity_per_stock
      //     .toString()
      //     .toLowerCase()
      //     .includes(searchQuery.toLowerCase())) ||
      // (item.wholesale_price_per_stock !== null &&
      //   item.wholesale_price_per_stock
      //     .toString()
      //     .toLowerCase()
      //     .includes(searchQuery.toLowerCase())) ||
      // (item.retail_price_per_stock !== null &&
      //   item.retail_price_per_stock
      //     .toString()
      //     .toLowerCase()
      //     .includes(searchQuery.toLowerCase())) ||
      // (item.quantity_stocked !== null &&
      //   item.quantity_stocked
      //     .toString()
      //     .toLowerCase()
      //     .includes(searchQuery.toLowerCase())) ||
      // (item.quantity_available !== null &&
      //   item.quantity_available
      //     .toString()
      //     .toLowerCase()
      //     .includes(searchQuery.toLowerCase()))
    );

    setStockData({ ...stockData, filtered: filteredData });
  };

  //save stock
  const saveStock = (e) => {
    e.preventDefault();
    const errors_arr = [];
    //loop through table and check for null bank detail entries
    const tbl_length = document.getElementById("stock_tbl").rows.length;
    console.log(tbl_length);

    const tbl = document.querySelector("#stock_tbl tbody").children;
    for (let trs of tbl) {
      const stock_added = trs.children[1].children[0].value;
      if (!stock_added) {
        errors_arr.push("Notice ! Enter stock Details");
      }
    }
    if (errors_arr.length > 0) {
      setMessage("Notice ! Enter stock Details");
      setIsMessageModal(true);
    } else {
      const frmData = new FormData(document.getElementById("stock_form"));
      const items = document.querySelectorAll(".items");
      const itemsAdded = document.querySelectorAll(".items_added");

      items.forEach((element) => {
        frmData.append("items[]", element.value);
      });
      itemsAdded.forEach((element) => {
        frmData.append("items_added[]", element.value);
      });
      
      

      frmData.append("user", sessionStorage.getItem("mwerezi_mpos_username"));

      //append access log details
      frmData.append("user_id", logData[0]);
      frmData.append("accessed_item", logData[1]);
      frmData.append("browser_type", logData[2]);
      frmData.append("os_type", logData[3]);

      postData(frmData, "save_stock")
        .then((data) => {
          if (data.length == 1) {
            setResponse(data);
            setResponseModal(true);
          } else {
            setResponse(data.message);
            setResponseModal(true);

            //append feedback for imported stock
            const tbl = document.querySelector(
              "#stock_import_tbl tbody",
            ).children;
            data.response.map((dt) => {
              for (let i = 0; i < tbl.length; i++) {
                const tr = tbl[i];
                const indexCol = tr.children[0].children[0].value;
                if (indexCol == dt.index) {
                  tr.children[7].children[0].value = dt.res;
                  let x = tr.children[7].children[0];
                  if (dt.res.includes("Error")) {
                    x.style.backgroundColor = "red";
                    x.style.color = "white";
                  } else {
                    x.style.backgroundColor = "green";
                    x.style.color = "white";
                  }
                }
              }
            });
          }
          document.getElementById("spinner").display = "none";
        })
        .catch((error) => {
          console.log(error);
          document.getElementById("spinner").display = "none";
        });
    }
  };
  //close message modal
  const closeMessageModal = () => {
    setResponseModal(false);
    // window.location.reload();
  };
   const logout = () => {
      if (typeof Storage !== "undefined") {
        localStorage.removeItem("mwerezi_mpos_username");
        localStorage.removeItem("mpos_fullname");
        localStorage.removeItem("mwerezi_mpos_usergroups");
        sessionStorage.removeItem("mpos_hasReloaded");
        ReactDOM.render(<Login />, document.getElementById("root"));
      } else {
        console.log("Sorry, something went wrong, please contact admin!");
      }
    };
  return (
    <div>
       <button className="btn btn-danger btn-sm" onClick={logout}>logout</button>
        <div className="m-3">
          <div className="row mb-3">
            <button
              className="btn btn-success btn-sm col-2"
              onClick={appendStockRow}
            >
              Add
            </button>

            <label
              className="col-form-label col-md-2 col-sm-2 label-align text-center pr-0 pl-0"
              for="member_no"
            >
              Import File:
            </label>
            <div className="col-md-4 col-sm-4 ">
              <input
                type="file"
                className="form-control"
                name="import_member_info"
                id="import_member_info"
                placeholder="Choose File"
                aria-required="true"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                onChange={(e) => {
                  const file = e.target.files[0];
                  readExcel(file);
                }}
              />
            </div>
            {/* <input
              type="text"
              className="form-control col-md-12"
              placeholder="Type to search..."
              // onInput={(e) => setSearchQuery(e.target.value)}
              onInput={handleSearch}
            /> */}
          </div>
          <form id="stock_form" onSubmit={saveStock}>
            <div className="col-md-12 justify-content-center">
              <table
                className="table table-bordered table-bordered table-sm"
                style={{ maxHeight: "500px" }}
                id={"stock_tbl"}
              >
                <thead className="table-fixed-header">
                  <tr>
                    <th>Id</th>
                    <th>Items</th>
                    <th>Expiry Date</th>
                    <th>Wholesale price per Item</th>
                    <th>Retail Price Per Item</th>
                    <th>Stocked</th>
                    <th>Sold</th>
                    <th>Expired / Spoilt</th>
                    <th>Available</th>
                    <th>Date Entered</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {stockData.filtered.map((dt, i) => {
                    return (
                      <tr key={dt.id}>
                        <td>
                          <input
                            type="text"
                            name="id[]"
                            value={dt.id}
                            readOnly
                          />
                        </td>
                        <td>
                          <select
                            className={"form-control-sm items"}
                            value={dt.item_code}
                            style={{ width: "300px" }}
                          >
                            <option disabled selected value="0">
                              Choose stock
                            </option>
                            {items.map((data) => {
                              return (
                                <option value={data.item_code}>
                                  {data.item_detail} 
                                </option>
                              );
                            })}
                          </select>
                        </td>
                        <td>
                          <input
                            className="form-control"
                            type="date"
                            name="expiry_date[]"
                            defaultValue={dt.expiry_date}
                          />
                        </td>

                        {/* <td>
                          <select
                            className={"form-control-sm units"}
                            style={{ width: "200px" }}
                            value={dt.unit_of_measurement}
                            onChange={(e) => {
                              const updated = [...stockData.filtered];
                              updated[i].unit_of_measurement = e.target.value;

                              setStockData({
                                ...stockData,
                                filtered: updated,
                              });
                            }}
                          >
                            <option value="0">Choose Units</option>
                            {units.map((dt) => {
                              return (
                                <option value={dt.code}>{dt.units}</option>
                              );
                            })}
                          </select>
                        </td> */}
                        {/* <td>
                          <input
                            type="number"
                            name="quantity[]"
                            className={"form-control"}
                            defaultValue={dt.quantity_per_item}
                          />
                        </td> */}
                        <td>
                          <input
                            type="number"
                            name="wholesale[]"
                            className={"form-control"}
                            defaultValue={dt.wholesale_price_per_item}
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            name="retail[]"
                            className={"form-control"}
                            defaultValue={dt.retail_price_per_item}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="stocked[]"
                            className={"form-control"}
                            defaultValue={dt.quantity_stocked}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            className={"form-control"}
                            value={dt.quantity_sold}
                            readOnly
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="quantity_expired_or_spoilt[]"
                            className={"form-control"}
                            defaultValue={dt.quantity_expired_or_spoilt}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="available[]"
                            className={"form-control"}
                            value={dt.quantity_available}
                            readOnly
                          />
                        </td>
                        <td>
                          <input
                            type="date"
                            className={"form-control"}
                            value={dt.date_entered}
                          />
                        </td>
                        <td></td>
                      </tr>
                    );
                  })}
                  {appendedStock.map((data) => {
                    return <tr key={data.id}>{data.new}</tr>;
                  })}
                </tbody>
              </table>
              <p className="text text-success fw-bolder h4">Imported stock</p>
              <table
                className="table table-bordered table-bordered table-sm"
                style={{ maxHeight: "500px" }}
                id={"stock_import_tbl"}
              >
                <thead className="table-fixed-header">
                  <tr>
                    <th>Id</th>
                    <th>Items</th>
                    <th>Expiry Date</th>
                    <th>Wholesale price per stock</th>
                    <th>Retail Price Per stock</th>
                    <th>Stocked</th>
                    <th>Expired / Spoilt</th>
                    <th>Feedback</th>
                  </tr>
                </thead>
                <tbody>
                  {stockImportData.map((data) => {
                    index++;
                    return (
                      <tr key={index}>
                        <td>
                          <input
                            className="form-control"
                            type="text"
                            name="index_import[]"
                            value={index}
                            style={{ width: "200px" }}
                            readOnly
                          />
                        </td>
                        <td>
                          <input
                            className="form-control"
                            type="text"
                            name="item_import[]"
                            defaultValue={data.item}
                            style={{ width: "200px" }}
                            readOnly
                          />
                        </td>
                        <td>
                          <input
                            className="form-control"
                            type="text"
                            name="expiry_date_import[]"
                            defaultValue={data.expiry_date}
                            style={{ width: "200px" }}
                            readOnly
                          />
                        </td>                    
                        <td>
                          <input
                            className="form-control"
                            type="text"
                            name="wholesale_price_per_item_import[]"
                            value={data.wholesale_price_per_item}
                            style={{ width: "200px" }}
                            readOnly
                          />
                        </td>
                        <td>
                          <input
                            className="form-control"
                            type="text"
                            name="retail_price_per_item_import[]"
                            value={data.retail_price_per_item}
                            style={{ width: "200px" }}
                            readOnly
                          />
                        </td>
                        <td>
                          <input
                            className="form-control"
                            type="text"
                            name="stocked_import[]"
                            value={data.stocked}
                            style={{ width: "200px" }}
                            readOnly
                          />
                        </td>
                        <td>
                          <input
                            className="form-control"
                            type="text"
                            name="expired_or_spoilt_import[]"
                            value={data.expired_or_spoilt}
                            style={{ width: "200px" }}
                            readOnly
                          />
                        </td>
                        <td>
                          <input
                            className="form-control"
                            type="text"
                            name="feedback[]"
                            readOnly
                            style={{ fontSize: "15px", width: "400px" }}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className={"row justify-content-center"}>
              <Spinner />
            </div>
            <div className={"row justify-content-center"}>
              <button className="btn btn-primary col-md-1" type="submit">
                Save
              </button>
            </div>
          </form>
        </div>
      {/*Message modal*/}
      <Modal5
        modalIsOpen={messageModal}
        // background="#0047AB"
        body={
          <div>
            <div className={"row"}>
              <p className="text-blue font-weight-bold h4">{message}</p>
            </div>
          </div>
        }
        buttons={
          <div className={"row"}>
            <button
              className="btn btn-outline-danger btn-sm"
              onClick={() => setIsMessageModal(false)}
            >
              OK
            </button>
          </div>
        }
      />
      {/*Response modal*/}
      <MessageModal
        modalIsOpen={responseModal}
        closeModal={closeMessageModal}
        background="#0047AB"
        body={<p className="text-white font-weight-bold h4">{response}</p>}
      />
    </div>
  );
};

export default AddStock;
